import BaseApi from './BaseApi';

class NotificationApi extends BaseApi {
  protected getSpecificApiPrefix(): string {
    return 'managers/notifies';
  }
}

export default NotificationApi;
